import { render, staticRenderFns } from "./EventTypeEdit.vue?vue&type=template&id=039d24b4"
import script from "./EventTypeEdit.vue?vue&type=script&lang=js"
export * from "./EventTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports